// extracted by mini-css-extract-plugin
export var section = "UqcXn54T";
export var headerContainer = "SMqY2+yS";
export var primaryTitle = "xe7BmT2t";
export var pattern = "sdK3dNMn";
export var blogCalculator = "_5IOxUD6T";